import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AppfaceLogo from "@/components/AppfaceLogo";

const footerLinks = [
  { label: "Services", path: "/services" },
  { label: "Solutions", path: "/solutions" },
  { label: "Mandi Trades", path: "/mandi-trades" },
  { label: "Videos", path: "/videos" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" }
];

const Footer = () => {
  return (
    <footer data-testid="footer" className="py-16 bg-[#1C1C1E] border-t border-white/5">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-2"
          >
            <Link to="/">
              <AppfaceLogo className="h-20 w-auto mb-4" />
            </Link>
            <p className="text-[#86868B] mb-4 max-w-md">
              Engineering and support services across Linux infrastructure, HPC operations, AI enablement, 
              and modern application development.
            </p>
            <p className="text-sm text-[#86868B]">
              Appface Technologies Pvt Ltd<br />
              Bengaluru, India
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h4 className="text-sm font-semibold text-[#F5F5F7] uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="footer-link text-sm"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(" ", "-")}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h4 className="text-sm font-semibold text-[#F5F5F7] uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-[#86868B]">
              <li>contact@appface.in</li>
              <li>Bengaluru, India</li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#86868B]" data-testid="footer-copyright">
            © 2026 Appface Technologies Pvt Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm footer-link">Privacy Policy</a>
            <a href="#" className="text-sm footer-link">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
